export default __webpack_public_path__ + "static/3-af257043b00da92afa758cbca5898c64.jpeg";